import React, { useState, useEffect } from "react";
import { Input, Textarea, Label } from "theme-ui";
import { InputWrap, LabelWrapper, Error, Prefix, InnerInputWrap, Suffix } from "./styled";

const TextInput = ({ 
  name, 
  label, 
  value, 
  description, 
  type,   
  autoComplete, 
  required,
  disabled, 
  readonly, 
  placeholder,
  prefix,
  suffix, 
  min, 
  max, 
  step, 
  $customStyles, 
  $errors, 
  $responseErrors, 
  rows,
  onKeyDown,
  onChange,
  onBlur 
}:{
  name?: string;
  label?: string | React.ReactNode;  
  value?: string | number;
  description?: string; 
  type?: any; 
  autoComplete?: string; 
  required?: boolean;
  readonly?: boolean;
  disabled?: boolean;
  placeholder?: string; 
  min?: string | number;
  max?: string | number;
  step?: string | number;
  $customStyles?: any;
  $responseErrors?: any;
  $errors?: any;
  rows?: number;
  prefix?: string | React.ReactNode;
  suffix?: string | React.ReactNode;
  onChange?: (e?: any) => void;
  onKeyDown?: (e?: any) => void;
  onBlur?: (e?: any) => void;
}) => {

  const [borderError, setBorderError] = useState(false);

  const setSelectValue = function (e: any){    
    if(disabled) return true;
      
    let value = e.target.value;
    if (type === "number") {
      value = parseFloat(value);
      if (isNaN(value)) {
        value = typeof min !== "undefined" ? Number(min) : "";
      } else if (typeof min !== "undefined" && value < Number(min)) {
        value = Number(min);
      }
      if (typeof max !== "undefined" && value > Number(max)) {
        value = Number(max);
      }
    }
     
    if(typeof onChange === "function"){
      onChange(value)
    }
  }

  useEffect(() => {
    if($responseErrors || $errors){
      setBorderError(true);
    }else{
      setBorderError(false);
    }
  },[$responseErrors, $errors]);

  return (
    <InputWrap $customStyles={$customStyles} $errors={borderError} rows={rows} prefix={prefix} suffix={suffix} readonly={readonly}>
      {label && 
        <LabelWrapper>
          <Label>{label}</Label>
          {required ? <span>*</span>  : ''}         
        </LabelWrapper>
      }
      {type === "textarea" ? 
        <Textarea 
          name={name} 
          disabled={disabled} 
          readOnly={readonly} 
          placeholder={placeholder} 
          autoComplete={autoComplete} 
          value={value ?? ""} 
          onChange={(e: any) => setSelectValue(e)}
          rows={rows} 
          style={{ resize: "none" }} 
        />
      :
      <InnerInputWrap>
        <Input 
          type={type || "text"} 
          name={name} 
          disabled={disabled} 
          readOnly={readonly} 
          placeholder={placeholder} 
          autoComplete={autoComplete} 
          onKeyDown={(e: any) => {
            if (typeof onKeyDown === "function") {
              onKeyDown(e);
            }
          }}
          onBlur={(e: any) => {
            if (typeof onBlur === "function") {
              onBlur(e);
            } else if (type === "number") {
              // fallback logic if not handled outside
              const val = parseFloat(e.target.value);
              if (isNaN(val)) {
                if (typeof min !== "undefined") {
                  setSelectValue({ target: { value: Number(min) } });
                }
              } else if (typeof min !== "undefined" && val < Number(min)) {
                setSelectValue({ target: { value: Number(min) } });
              }
            }
          }}
          min={min}
          max={max}
          step={step}
          value={value ?? ""} 
          onChange={(e: any) => setSelectValue(e)}    
          sx={{
            "::-webkit-inner-spin-button": { display: "none" },
            "::-webkit-outer-spin-button": { display: "none" },
            "-moz-appearance": "textfield",
          }}    
        />
        {prefix && 
        <Prefix>{prefix}</Prefix>
        }
        {suffix &&
        <Suffix>{suffix}</Suffix>
        }
        </InnerInputWrap>
      }
      {description && <p><small>{description}</small></p>}       
      {$errors && <Error>{$errors}</Error>}
    </InputWrap>    
  );
};

export default TextInput;
